<template>
  <div id="home">
    <img src="../assets/imgs/logo.png" alt="" class="logo_mask">
    <div class="text_mask">
      <p>中铁桥隧招标网</p>
      <p>透明规范，诚实信用</p>
      <div class="btn" @click="$router.push('login')">去登录<Icon style="margin-left:15px" type="ios-navigate" /></div>
    </div>
    <Carousel v-model="value2" arrow="never">
      <CarouselItem>
        <img src="../assets/imgs/back1.png" alt="">
      </CarouselItem>
      <!--<CarouselItem>
        <img src="../assets/imgs/back2.png" alt="">
      </CarouselItem>-->
    </Carousel>
    <div class="list_info">
      <div class="header">
        <div class="title">
          <span></span>
          <p>招投标信息</p>
        </div>
        <!-- <div class="action" @click="$router.push('login')">
          更多<Icon type="ios-arrow-forward" />
        </div> -->
      </div>
      <div class="content">
        <Scroll :on-reach-bottom="getData" :height="height">
          <div v-for="i in list" :key="i.id" class="list_item">
            <div @click="clickPname(i)">{{i.pname}}</div>
            <div>{{i.time}}</div>
          </div>
        </Scroll>
      </div>
    </div>
    <div class="footer">Copyright © 2021中铁桥隧技术有限公司【苏ICP备15036412号-3】</div>
    <Modal
        v-model="modal"
        title="采购信息"
        width="40%"
        style="min-width:480px"
        class-name="vertical-center-modal">
      <Form :model="details" inline :label-width='150'>
        <FormItem label="项目名称: " style="width:100%">{{details.pname}}</FormItem>
        <FormItem label="项目概况及采购范围: " style="width:100%">{{details.overview}}</FormItem>
        <FormItem label="联系人: ">{{details.contact}}</FormItem>
        <FormItem label="联系电话: ">{{details.contactNumber}}</FormItem>
        <FormItem label="报名起始时间: ">{{details.registrationStartTime}}</FormItem>
        <FormItem label="报名截止时间: ">{{details.registrationDeadline}}</FormItem>
        <FormItem label="开标时间: ">{{details.tenderOpenTime}}</FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { getPurchaseAnnouncementPage,getPurchaseAnnouncementDetail } from '@/api/api'
export default {
  data () {
    return {
      value2: 0,
      list: [],
      query: {
        pageNum: 0,
        pageSize: 10
      },
      modal: false,
      details: {},
      height:'',
    }
  },
  mounted() {
    let chazhi = document.body.clientHeight < 800 ? 90 : 130 ;
    this.height = document.body.clientHeight / 2 - chazhi ;
    window.onresize = () => {
      return (() => {
        this.height = document.body.clientHeight / 2 - chazhi ;
      })()
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.query.pageNum ++
      return getPurchaseAnnouncementPage(this.query).then(res => {
        setTimeout(() => {
          this.list = this.list.concat(res.list)
        }, this.query.pageNum===1?0:2000)
      }).catch(err => console.log(err))
    },
    clickPname (row) {
      getPurchaseAnnouncementDetail(row.id).then(res => {
        this.details = res
        this.modal = true
      }).catch(err => console.log(err))
    },
  }
}
</script>
<style lang='scss' scoped>
 #home {
  height: 100vh;
  width: 100%;
  position: relative;
  .ivu-carousel {
    height: 50vh;
    width: 100%;
    ::v-deep .ivu-carousel-item {
      img {
        height:50vh;
        width:100%;
      }
    }
  }
  .logo_mask {
    position: absolute;
    top: 34px;
    left: 60px;
    z-index: 999;
  }
  .text_mask {
    position: absolute;
    font-weight: bold;
    color: #FFFFFF;
    z-index: 2;
    line-height: 40px;
    top: 15%;
    left: -20vw;
    width: 100%;
    text-align: center;
    p:first-child {
      font-size: 50px;
    }
    @media screen and (max-width: 1500px) and (min-width: 1000px) {
      p:first-child {
        margin-top: 15px;
        font-size: 45px !important;
      }
    }
    p:nth-child(2) {
      font-size: 26px;
      margin: 30px 0 60px 0;
    }
    .btn {
      width: 188px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 2px;
      font-size: 22px;
      color: #006DC8;
      line-height: 54px;
      display: inline-block;
    }
  }
  .list_info {
    // padding-top: 20px;
    width: 50vw;
    position: absolute;
    height: calc(50vh - 56px);
    left: 50%;
    transform: translateX(-50%);
    .header {
      display: flex;
      justify-content: space-between;
      padding: 30px;
      line-height: 26px;
      .title {
        display: flex;
        span{
          width: 8px;
          height: 26px;
          background: #006DC8;
          display: inline-block;
        }
        p {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          margin-left: 12px;
        }
      }
      // .action {
      //   font-size: 18px;
      //   color: #666;
      //   cursor: pointer;
      //   &:hover {
      //     color: #006DC8
      //   }
      //   .ivu-icon {
      //     margin-left: 10px;
      //     font-size: 20px;
      //   }
      // }
    }
    .content {
      .list_item {
        height: 60px;
        display: flex;
        line-height: 60px;
        padding: 0 30px;
        justify-content: space-between;
        font-size: 18px;
        color: #333333;
        &:nth-child(odd){
          background: #F6F6F6;
        }
        div:first-child:hover {
          cursor: pointer;
          color: #006DC8;
          text-decoration: underline;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 56px;
    background: #333333;
    position: absolute;
    bottom: 0;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
  }
 }
 ::v-deep .ivu-scroll-container{
   overflow-y:auto
 }
 ::v-deep .ivu-form-item {
   width: 48%;
   color: #333;
   .ivu-form-item-label {
     color: #666;
   }
 }
</style>

<style lang="scss" scoped>
  ::v-deep .ivu-carousel-dots-inside {
    display: none;
  }
</style>
